<template>
	<div class="modules px-12">
		<NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
				<v-list flat>
					<v-list-item-group>
						<v-list-item
							v-for="module in modules"
							:key="module.id"
							style="border: 1px solid #e0e0e0; border-radius: 5px"
							color="primary"
						>
							<v-list-item-icon class="mr-3">
								<v-icon color="primary">add_to_queue</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>{{module.name}}</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action class="primary--text">
								<v-tooltip top>
									<template v-slot:activator="{ on }">
										<v-btn icon v-on="on" :to="{name: 'edit-module', params: {mid: module.id, module: module}}">
											<v-icon color="primary">edit</v-icon>
										</v-btn>
									</template>
									<span>Edit</span>
								</v-tooltip>
							</v-list-item-action>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</v-container>
		</v-main>
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import axios from "axios";

export default {
	name: "Modules",
	components: {
		NavBar
	},
	data: () => ({
		modules: []
	}),
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Modules"),
					disabled: true,
					link: true
				}
			];
		}
	},
	created() {
		axios
			.get("/admin/dashboard/modules")
			.then(response => {
				console.log(response.data);
				this.modules = response.data.modules;
			})
			.catch(error => console.log(error));
	}
};
</script>